import { join } from "@/utils/join"

interface Props {
  left: string
  right: string
  isToggled: boolean
  onChange: () => void
}

export const Toggle = ({ left, right, onChange, isToggled }: Props) => {
  const buttonClass = join(
    "flex-1 flex justify-center items-center z-20 rounded-full cursor-pointer",
  )
  return (
    <div className="relative box-border flex h-7 w-full justify-between rounded-full border-2 border-tertiary bg-secondary">
      <button className={buttonClass} onClick={onChange}>
        <span
          className={`text-md-semibold transition-colors duration-500 ${isToggled ? "text-disabled" : "text-white"}`}
        >
          {left}
        </span>
      </button>
      <button className={buttonClass} onClick={onChange}>
        <span
          className={`text-md-semibold transition-colors duration-500 ${isToggled ? "text-white" : "text-disabled"}`}
        >
          {right}
        </span>
      </button>
      <div
        className={join(
          "absolute h-full w-6/12 rounded-full transition-all duration-500",
          isToggled ? "left-6/12 bg-sell-primary" : "left-0 bg-buy-primary",
        )}
      />
    </div>
  )
}
